import { render, staticRenderFns } from "./GekkoButton.vue?vue&type=template&id=2feed9b6&scoped=true&"
import script from "./GekkoButton.vue?vue&type=script&lang=js&"
export * from "./GekkoButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feed9b6",
  null
  
)

export default component.exports